import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-hierarchy-multiselect',
  templateUrl: './hierarchy-multiselect.component.html',
  styleUrls: ['./hierarchy-multiselect.component.scss']
})
export class HierarchyMultiselectComponent implements OnInit {
  active: boolean;
  @Input() config = {
    searchableField: "name",
    titleField: "name",
    idField: 'id'
  }
  @Input() parentName = "Parent";
  @Input() items = [
    {
      name: "Item 1",
      id: 1,
      selected: false
    },
    {
      name: "Item 2",
      id: 2,
      selected: false
    },
    {
      name: "Item 3",
      id: 3,
      selected: false
    }
  ];
  @Output() itemsValueChange = new EventEmitter();
  parentValue: boolean;
  constructor() { }

  ngOnInit() {
  }

  parentSelected() {
    if (!this.items) return;

    this.items.forEach(item => {
      item.selected = this.parentValue;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/hierarchy-multiselect/hierarchy-multiselect.component.ts